import { render } from "./MediaUploader.vue?vue&type=template&id=10815cde&scoped=true"
import script from "./MediaUploader.vue?vue&type=script&lang=js"
export * from "./MediaUploader.vue?vue&type=script&lang=js"

import "./MediaUploader.vue?vue&type=style&index=0&id=10815cde&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10815cde"]])

export default __exports__